import { render, staticRenderFns } from "./content-objective.vue?vue&type=template&id=19d7d4da&scoped=true"
import script from "./content-objective.ts?vue&type=script&lang=ts&external"
export * from "./content-objective.ts?vue&type=script&lang=ts&external"
import style0 from "./content-objective.less?vue&type=style&index=0&id=19d7d4da&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7d4da",
  null
  
)

export default component.exports